module.exports = __webpack_public_path__ + "fonts/LLSariTab/LLSariTab_2aa26fc4a8de11702ddfdef6a4d7efa8.ttf";